module.exports = __webpack_public_path__ + "static/media/icon-neighbor.ce56f47f.svg";